import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WIDGET } from '@main/enums';
import { MultiCasePipe } from '@app/shared/pipes/multi-case/multi-case.pipe';
import { WidgetSkeletonService } from '@shared/services/widget-skeleton/widget-skeleton.service';

/**
 * A component that displays a placeholder that appears during loading data for
 * the specified widget type.
 */
@Component({
    selector: 'widget-skeleton',
    standalone: true,
    imports: [CommonModule, MultiCasePipe],
    templateUrl: './widget-skeleton.component.html',
    styleUrls: ['./widget-skeleton.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetSkeletonComponent {
    @Input({ required: true }) type: WIDGET;
    @Input() isFullscreenView = false;

    protected WIDGET = WIDGET;

    private readonly service = inject(WidgetSkeletonService);

    get skeletonRows(): number | undefined {
        const options = this.service.getOptions(this.type);
        return this.isFullscreenView && options?.rowsInFullScreen ? options?.rowsInFullScreen : options?.rows;
    }
}
